module.exports = __webpack_public_path__ + "static/media/feature-formula-language.1ce81237.svg";